/**
 *
 * Asynchronously loads the SendEmailPopup component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
